export const getMockCompanyNameSlug = (
  companySlug: string,
  isLegacyUrl: boolean,
) => ({
  companySlug,
  status: isLegacyUrl ? 'TEMP_REDIRECT' : 'NO_REDIRECT',
});
